import React, { useEffect, useState } from 'react';
import { CheckCircle2, X } from 'lucide-react';
const names = ['Martín', 'Lucas', 'Sofía', 'Camila', 'Juan', 'Agustina', 'Facundo', 'Micaela', 'Diego', 'Valentina'];
const cities = ['Córdoba', 'Rosario', 'Mendoza', 'CABA', 'La Plata', 'Mar del Plata', 'Tucumán', 'Salta', 'Santa Fe', 'Neuquén'];
const INTERVAL_MS = 30000; // 30s between popups
const VISIBLE_MS = 5000; // popup stays visible 5s
const INITIAL_DELAY_MS = 8000; // wait 8s before showing the first one
export function PurchasePopup() {
  const [visible, setVisible] = useState(false);
  const [data, setData] = useState({
    name: '',
    city: '',
    time: ''
  });
  useEffect(() => {
    let hideTimer: ReturnType<typeof setTimeout>;
    const showPopup = () => {
      const randomName = names[Math.floor(Math.random() * names.length)];
      const randomCity = cities[Math.floor(Math.random() * cities.length)];
      const randomTime = Math.floor(Math.random() * 59) + 1;
      setData({
        name: randomName,
        city: randomCity,
        time: `${randomTime} min`
      });
      setVisible(true);
      hideTimer = setTimeout(() => setVisible(false), VISIBLE_MS);
    };
    const initialTimer = setTimeout(showPopup, INITIAL_DELAY_MS);
    const interval = setInterval(showPopup, INTERVAL_MS);
    return () => {
      clearTimeout(initialTimer);
      clearTimeout(hideTimer);
      clearInterval(interval);
    };
  }, []);
  if (!visible) return null;
  return <div className="fixed bottom-4 left-4 z-50 animate-fade-in-up" data-id="element-286">
      <div className="bg-white border border-stone-200 rounded-xl shadow-xl p-4 flex items-start gap-4 pr-10 relative max-w-sm" data-id="element-287">
        <button onClick={() => setVisible(false)} className="absolute top-2 right-2 text-stone-400 hover:text-stone-600" aria-label="Cerrar" data-id="element-288">
          <X className="w-4 h-4" data-id="element-289" />
        </button>

        <div className="bg-green-50 p-2 rounded-full flex-shrink-0" data-id="element-290">
          <CheckCircle2 className="w-6 h-6 text-green-500" data-id="element-291" />
        </div>

        <div data-id="element-292">
          <p className="text-sm text-stone-600" data-id="element-293">
            <span className="font-bold text-stone-900" data-id="element-294">{data.name}</span> de{' '}
            {data.city}
          </p>
          <p className="text-xs text-coral-500 font-bold mt-1" data-id="element-295">
            Compró Megapack Élite
          </p>
          <p className="text-xs text-stone-400 mt-1" data-id="element-296">Hace {data.time}</p>
        </div>
      </div>
    </div>;
}